import {
  createBaseThemeOptions,
  createUnifiedTheme,
  defaultTypography,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const accionaLightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: 'rgb(255, 0, 0)', // Rojo Acciona
      },
      secondary: {
        main: 'rgb(0, 0, 0)', // Negro
      },
      background: {
        default: 'rgb(255, 255, 255)', // Fondo blanco
        paper: 'rgb(255, 255, 255)',   // Fondo para tarjetas
      },
      common: {
        black: 'rgb(0, 0, 0)',
        white: 'rgb(255, 255, 255)',
      },
      navigation: {
        background: 'rgb(245, 245, 245)',  // Fondo del menú
        indicator: 'rgb(255, 0, 0)',   // Indicador de selección
        color: 'rgb(0, 0, 0)',       // Texto del menú
        selectedColor: 'rgb(255, 0, 0)', // Texto seleccionado
        navItem: {
          hoverBackground: 'rgb(198, 198, 198)',
        },
        submenu: {
          background: 'rgb(245, 245, 245)',
        },
      },
    },
  }),
  defaultPageTheme: 'home',
  typography: {
    ...defaultTypography,
    fontFamily: "Acciona",
  },

  components: {
    BackstageHeader: {
      styleOverrides: {
        header: {
          // display: 'none',
        },
      },
    },
    BackstagePage: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.default,
        }),
      },
    },
  },
  
  pageTheme: {
    home: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    documentation: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    other: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.round,
    }),
    app: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.round,
    }),
    apis: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.round,
      options: {
        fontColor: 'rgb(255, 255, 255)',
      },
    }),
    card: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    application: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.round,
    }),
    project: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    request: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    default: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    generic: genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    'SRC (Código Aplicación)': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    'IAC - Código de Infraestuctura': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    'TEST - Código pruebas Automatizadas': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave,
    }),
    'Proyecto': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    'Evolutivo Multitarea': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    'Mantenimiento de Aplicaciones': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    'Desarrollo SW': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    'Provisión de Infraestructuras': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    'Puesto de trabajo y Colaboracion': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
    'Habilitación de Sites/Instalaciones': genPageTheme({
      colors: ['rgb(0, 125, 156)', 'rgb(0, 125, 156)'],
      shape: shapes.wave2,
    }),
  },
});
